import Modal from "react-modal";

import LoginPage from "./components/login/LoginPage";
import RequireAuth from "./components/login/RequireAuth";
import { Routes, Route, useNavigate } from "react-router-dom";

import AdminHome from "./components/pages/AdminHome";
import OperatorHome from "./components/pages/OperatorHome";
import SupervisorHome from "./components/pages/SupervisorHome";
import Unauthorized from "./components/pages/Unauthorized";
import Missing from "./components/pages/Missing";
import ForgotPassword from "./components/pages/ForgotPassword";
import ManualEntry from "./components/pages/ManualEntry";
import Scan from "./components/pages/Scan";
import StockistReport from "./components/pages/StockistReport";
import UploadReconcilation from "./components/reconcilation/UploadReconcilation";
import ReconciledReport from "./components/reconcilation/ReconciledReport";
import HotkeysHandler from "./hooks/HotkeysHandler";
import ReconcilationVerification from "./components/reconcilation/ReconcilationVerification";
import ManualEntryView from "./components/manual_table_view/ManualEntryView";
import { ReactSession } from "react-client-session";
import Loader from "./components/Loader";

function App() {
  ReactSession.setStoreType("sessionStorage");
  Modal.setAppElement("#root");

  const navigate = useNavigate();

  const accessToken = ReactSession.get("accessToken");
  const role = ReactSession.get("role");

  const navigateToManualEntryHandler = () => {};

  return (
    <div>
      <HotkeysHandler
        keys="shift+alt+m"
        handler={() => {
          if (accessToken && role === "3") {
            navigate("/manual-entry");
          }
        }}
      />

      <HotkeysHandler
        keys="shift+alt+s"
        handler={() => {
          if (accessToken && role === "3") {
            navigate("/scan");
          }
        }}
      />

      <HotkeysHandler
        keys="shift+alt+h"
        handler={() => {
          if (accessToken && role === "3") {
            navigate("/operator");
          }
        }}
      />
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="*" element={<Missing />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        {/* PRIVATE ROUTES */}
        {/* ADMIN  */}
        <Route element={<RequireAuth allowedRole={["1"]} />}>
          <Route path="/admin" element={<AdminHome />} />
        </Route>
        {/* SUPERVISOR  */}

        <Route element={<RequireAuth allowedRole={["2", "3"]} />}>
          <Route path="/upload" element={<UploadReconcilation />} />
          <Route path="/reconciled-report" element={<ReconciledReport />} />
          <Route path="/reconcilation" element={<ReconcilationVerification />} />
          <Route path="/stockist-report" element={<StockistReport />} />
          <Route path="/manual-entry-view" element={<ManualEntryView />} />
        </Route>

        <Route element={<RequireAuth allowedRole={["2"]} />}>
          <Route path="/supervisor" element={<SupervisorHome />} />
        </Route>
        {/* OPERATOR  */}

        <Route element={<RequireAuth allowedRole={["3"]} />}>
          <Route path="/operator" element={<OperatorHome />} />
          <Route path="/manual-entry" element={<ManualEntry />} />
          <Route path="/scan" element={<Scan />} />
        </Route>
      </Routes>
      <Loader />
    </div>
  );
}

export default App;
